/**
 * Generates the URL for an agency's job board
 * @param agencyId - The ID of the agency
 * @returns The job board URL
 */
export const getJobBoardUrl = (agencyId: string): string => {
  return `/job_board/${agencyId}`;
};

/**
 * Generates the URL for a specific job on an agency's job board
 * @param agencyId - The ID of the agency
 * @param jobId - The ID of the job
 * @returns The job board job URL
 */
export const getJobBoardJobUrl = (agencyId: string, jobId: string): string => {
  return `/job_board/${agencyId}/job/${jobId}`;
};


/**
 * Opens a URL in a new browser tab
 * @param url - The URL to open
 */
export const openInNewTab = (url: string): void => {
  window.open(url, '_blank');
};
